module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk med tjenesteløfte_primærlogo_pos(svart).d017faa3.pdf";